import React from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  Button,
  Container,
} from "@mui/material";

const CaseStudyCard = ({ caseStudy }) => {
  return (
    <Box
      sx={{
        maxWidth: "100%",
        p: 4,
        textAlign: "center",
        bgcolor: "transparent", // Set background color
        color: "white",
      }}
    >
      <Container>
        {/* Section Title */}
        <Typography variant="h5" fontWeight="bold" color="white" mb={1}>
          {caseStudy.sectionTitle}
        </Typography>
        <Typography variant="body1" color="white" mb={3}>
          {caseStudy.sectionSubtitle}
        </Typography>

        {/* Case Study Card */}
        <Card
          sx={{
            borderRadius: 4,
            background: "#7f829a",
            border: "2px solid #F4DBF5",
            backdropFilter: "blur(12px)",
            overflow: "hidden",
            p: 2,
          }}
        >
          <Grid container spacing={2} alignItems="start">
            {/* Image Section */}
            <Grid item xs={12} md={4}>
              <Box
                sx={{
                  width: "100%",
                  height: "100%",
                  overflow: "hidden",
                  borderRadius: "12px",
                }}
              >
                {typeof caseStudy.image === "string" ? (
                  <img
                    src={caseStudy.image}
                    alt={caseStudy.imageAlt}
                    style={{ width: "100%", height: "auto", objectFit: "cover" }}
                  />
                ) : (
                  caseStudy.image
                )}
              </Box>
            </Grid>

            {/* Content Section */}
            <Grid item xs={12} md={8} textAlign="left">
              <CardContent>
                <Typography variant="h5" fontWeight="bold" color="white" mb={1}>
                  {caseStudy.title}
                </Typography>
                <Typography variant="body2" fontSize={14} color="white" mb={2}>
                  {caseStudy.description}
                </Typography>
                <a
                  href="https://www.royalespaces.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none" }}
                >
                  <Button
                    variant="contained"
                    sx={{
                      background: "transparent",
                      borderRadius: "20px",
                      color: "#F4DBF5",
                      textTransform: "none",
                      border: "3px solid #E8B7EB",
                      px: 3,
                      "&:hover": {
                        borderColor: "#C42776",
                        color: "#C42776",
                      },
                    }}
                  >
                    {caseStudy.buttonText}
                  </Button>
                </a>
              </CardContent>
            </Grid>
          </Grid>
        </Card>

        {/* View More Link */}
        {/* <Typography variant="body2" mt={3}>
          <Button
            sx={{ color: "#fff", textTransform: "none", fontWeight: "bold" }}
          >
            {caseStudy.viewMoreText}
          </Button>
        </Typography> */}
      </Container>
    </Box>
  );
};

export default CaseStudyCard;
